$(function () {
    "use strict";
    var $document = $(document),
		plugins = {
            eventFiltersWrapper: $(".event-filters-wrapper"),
            formSearch: $("#form-search"),
            forPage: $("#for-page"),
            txtQty: $("input[class*='txtQty']"),            
            contactMessage: $("#contactMessage"), 
            FormMessage: $("#form-message"), 
            locationFilter: $("#location-filter"),
            homeProperty: $("#home-property"),
            agentData: $("#agent-data"),
        };

    $document.ready(function () {
        // check for saved 'darkMode' in localStorage
        let darkMode = localStorage.getItem('darkMode'); 

        const darkModeToggle = document.querySelector('#dark-mode-toggle');

        const enableDarkMode = () => {
            // 1. Add the class to the body
            //   document.body.classList.add('darkmode');
            $("html").attr("theme", "dark");
            $('.theme-switcher').addClass('active')
            // 2. Update darkMode in localStorage
            localStorage.setItem('darkMode', 'enabled');
            $(".logo img").addClass("brightness");
            $(".filter-icon img").addClass("rss opacity");
        }

        const disableDarkMode = () => {
            // 1. Remove the class from the body
            //   document.body.classList.remove('darkmode');
            $("html").attr("theme", "light");
            $('.theme-switcher').removeClass('active')
            // 2. Update darkMode in localStorage 
            localStorage.setItem('darkMode', null);
            $(".logo img").removeClass("brightness");
            $(".filter-icon img").removeClass("rss opacity");
        }
        
        // If the user already visited and enabled darkMode
        // start things off with it on
        if (darkMode === 'enabled') {
            enableDarkMode();
        }

        // When someone clicks the button
        darkModeToggle.addEventListener('click', () => {
            $('html').addClass('color-theme-in-transition');
            // get their darkMode setting
            darkMode = localStorage.getItem('darkMode'); 
            // if it not current enabled, enable it
            if (darkMode !== 'enabled') {
                enableDarkMode();
            // if it has been enabled, turn it off  
            } else {  
                disableDarkMode(); 
            }
            $.post(base_url + '/set-theme', { mode: darkMode });
            window.setTimeout(function() 
            {
                $('html').removeClass('color-theme-in-transition')
                
            }, 1000)
        });

        toastr.options = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": "toast-top-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "3000",
            "extendedTimeOut": "3000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
        
        // Set CSRF
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        if($('.bxslider').length) {
            $('.bxslider').bxSlider({
                pagerCustom: '#bx-pager',
                adaptiveHeight: true
            });
        }

        if(plugins.homeProperty.length) {
            
            plugins.homeProperty.on('click', '.pagination a',function(event)
            {
                event.preventDefault();
    
                $('li').removeClass('active');
                $(this).parent('li').addClass('active');
    
                let url = new URL($(this).attr('href'));
                let page = url.searchParams.get('page');

                getData(page, {
                    type: url.searchParams.get('type'),
                    province: url.searchParams.get('province'),
                    district: url.searchParams.get('district'),
                    commune: url.searchParams.get('commune'),
                });
            });
        }

        if(plugins.agentData.length) {
            
            plugins.agentData.on('click', '.pagination a',function(event)
            {
                event.preventDefault();
                $('li').removeClass('active');
                $(this).parent('li').addClass('active');
    
                var myurl = $(this).attr('href');
                var page=$(this).attr('href').split('page=')[1];
                getDataAgent(page);
            });
        }

        // Contact Message
        if(plugins.contactMessage.length) {
            $document.on('click', '#contactMessage', function(e){
                var ref = $(this).data('ref');
                var propertyid = $(this).data('property-id');
                var agent = $(this).data('agent');
                var email = $(this).data('email');
                var comment = $(this).data('comment');
                
                var modal = $("#contactMessageModal");
                modal.find('form input[name=referenceid]').val(ref);
                modal.find('form input[name=propertyid]').val(propertyid);
                modal.find('form input[name=agent_name]').val(agent);
                modal.find('form input[name=agent_email]').val(email);
                modal.find('form textarea[name=comment]').val(comment);
                return true;   
            });
        }
		
		// Allow only Number
        if(plugins.txtQty.length){
            plugins.txtQty.keydown(function (event) {
                if (event.shiftKey == true)  event.preventDefault();
                if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 46 || event.keyCode == 190) { } else event.preventDefault();        
                if($(this).val().indexOf('.') !== -1 && event.keyCode == 190) event.preventDefault();
            });
        }

        // Form Contact
        if(plugins.FormMessage.length) {
            $(document).on('submit', '#form-message', function(e) {
                e.preventDefault();
                $('input+small').text('');
                $('input').removeClass('is-invalid');
                $('.btn-submit').hide();
                $('.btn-loading').show();				
                $.ajax({
                    method: $(this).attr('method'),
                    url: $(this).attr('action'),
                    data: $(this).serialize(),
                    dataType: "json"
                })
                .done(function(data) {
                    if(data.status == 'success'){
                        $('#contactMessageModal').modal('hide');
                        toastr.success(data.message);
                        $('.btn-loading').hide();
                        $('.btn-submit').show();
                    }else{
                        if(data.status == 'error'){
                        	toastr.error(data.message);
                        }else{
                        	toastr.warning(data.message, 'Warning');
                        }
                        $('.btn-loading').hide();
                        $('.btn-submit').show();
                    }					
                })
                .fail(function(data) {
                    $("#form-message input").removeClass('is-invalid');
                    $.each(data.responseJSON, function (key, value) {
                        var input = '#form-message input[name=' + key + ']';
                        $(input + '+small').text(value);
                        $(input).addClass('is-invalid');
                    });
                    $('.btn-loading').hide();
                    $('.btn-submit').show();
                });
            });
        }

        // Filter toolbar
        if(plugins.eventFiltersWrapper.length) {
            $("#district").prop('disabled', true);
            $("#commune").prop('disabled', true);
            plugins.eventFiltersWrapper.on('change', '#province',  function() {
                let val = $(this).val();
                let url = $(this).data('url');
                let csrf = $(this).data('csrf');        
                if(val != ''){
                    var request = $.ajax({
                        url: url,
                        method: "POST",
                        data: { code : val, _token: csrf}
                    });
                    request.done(function( resp ) {
                        if(resp.status == true){
                            getData('', {province: val});
                            append_child(resp.data.data, '#district', 'district','district').change();
                            $("#district").prop('disabled', false);
                            $("#commune").prop('disabled', true);
                            $("#commune").html('<option value="">Commune</option>');
                        }
                    });			
                    request.fail(function( jqXHR, textStatus ) {
                        toastr.warning('Request failed: '+ textStatus);
                    });
                }else{
                    getData('');
                    $("#district").prop('disabled', true);
                    $("#commune").prop('disabled', true);
                }
            });

            plugins.eventFiltersWrapper.on('change', "#district", function() {
                let val = $(this).val();
                let url = $(this).data('url');
                let csrf = $(this).data('csrf');      
                if(val != ''){
                    var request = $.ajax({
                        url: url,
                        method: "POST",
                        data: { code : val, _token: csrf}
                    });
                    request.done(function( resp ) {      
                        if(resp.status == true){
                            getData('', {province: $("#province").val(), district: val});
                            append_child(resp.data.data,'#commune','commune','commune').change();
                            $("#commune").prop('disabled', false);
                        }
                    });			
                    request.fail(function( jqXHR, textStatus ) {
                        toastr.warning('Request failed: '+ textStatus);
                    });
                }else{
                    getData('', {province: $("#province").val()});
                    $("#commune").prop('disabled', true);
                }
            });

            plugins.eventFiltersWrapper.on('change', "#commune", function() {
                if(typeof($(this).val()) != "undefined" && $(this).val() !== null)
                    getData('', {province: $("#province").val(), district: $("#district").val(), commune: $(this).val()});
                else
                    getData('', {province: $("#province").val(), district: $("#district").val()});
            });
        }

        // Search page
        if(plugins.formSearch.length) {            
            plugins.formSearch.on('change', '#province-search',  function() {
                let val = $(this).val();
                let url = $(this).data('url');
                let csrf = $(this).data('csrf');        
                if(val != ''){
                    var request = $.ajax({
                        url: url,
                        method: "POST",
                        data: { code : val, _token: csrf}
                    });
                    request.done(function( resp ) {
                        if(resp.status == true){
                            append_child(resp.data.data, '#district-search', 'district','district').change();
                            $("#district-search").prop('disabled', false);
                            $("#commune-search").prop('disabled', true);
                            $("#commune-search").html('<option value="">Commune</option>');
                        }
                    });			
                    request.fail(function( jqXHR, textStatus ) {
                        toastr.warning('Request failed: '+ textStatus);
                    });
                }else{
                    $("#district-search").html('<option value="">District</option>');
                    $("#district-search").prop('disabled', true);
                    $("#commune-search").prop('disabled', true);
                }
                    
            }).change();

            plugins.formSearch.on('change', "#district-search", function() {
                let val = $(this).val();
                let url = $(this).data('url');
                let csrf = $(this).data('csrf');      
                if(val != ''){
                    var request = $.ajax({
                        url: url,
                        method: "POST",
                        data: { code : val, _token: csrf}
                    });
                    request.done(function( resp ) {      
                        if(resp.status == true){
                            append_child(resp.data.data,'#commune-search','commune','commune').change();
                            $("#commune-search").prop('disabled', false);
                        }
                    });			
                    request.fail(function( jqXHR, textStatus ) {
                        toastr.warning('Request failed: '+ textStatus);
                    });
                }else{
                    $("#commune-search").prop('disabled', true);
                }
            });
        }
        
    });

    var clipboard = new ClipboardJS('.clipboard');

    clipboard.on('success', function(e) 
    {
        toastr.success('Copied to clipboard', 'Success');
    });


    $(document).ajaxSuccess(function () {
        $("[data-toggle=tooltip]").tooltip();
    });

});

function is_touch_device() {
    return 'ontouchstart' in window;
}

// Sharing
window.shareTo = function shareTo(url, social, title)
{		
	
	if(navigator.share !== undefined) 
	{	
		navigator.share({
			title: title,
			text: "Zillionhome.com",
			url: url
		}).then(() => alert('Successful share'))
		.catch(error => console.log('Error sharing: ' + error));
	}
	else 
	{		
		if(social=='fb')
		window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(url), 'facebook-share-dialog', 'width=626,height=436'); 
		
		else if(social=='tw')
		window.open('https://twitter.com/share?url=' + encodeURI(url) + '&text=' + title, 'twitter-share-dialog', 'width=626,height=436'); 
		
		else if(social=='gp')
		window.open('https://plus.google.com/share?url=' + encodeURI(url), 'google-share-dialog', 'width=626,height=436'); 
		
		else if(social=='in')
		window.open('https://www.linkedin.com/shareArticle?url=' + encodeURI(url) + '&title=' + title, 'linkedin-share-dialog', 'width=626,height=436'); 
		
		else if(social=='pn')
		window.open('https://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&description=' + title, 'pinterest-share-dialog', 'width=626,height=436'); 
		
		else if(social=='mg')
		window.open('https://web.facebook.com/dialog/send?link=' + encodeURI(url) + '&app_id=133048710662420&redirect_uri=' + encodeURI(url) + '&_rdc=1&_rdr', 'messenger-share-dialog', 'width=1000,height=800'); 
		
	}		
}


window.append_child = function append_child(data,el,opt,get){
    let items = [];
        items.push('<option value="">'+ucfirst(opt)+'</option>');   
        
    $.each(data, function(key, val) {		
        items.push('<option value="'+ val['postal_code'] + '">' + val['en_name'] + '</option>');
    });    
    return $("select" + el).html(items.join(""));
}

function ucfirst(str,force){
    str=force ? str.toLowerCase() : str;
    return str.replace(/(\b)([a-zA-Z])/,
             function(firstLetter){
                return   firstLetter.toUpperCase();
             });
}

window.getData = function getData(page, option = null){
    var data = {};
    data['page'] = page;
    if($('input[type=radio][name=for]:checked').length){
        data['for'] = $('input[type=radio][name=for]:checked').val();
    }else{
        data['for'] = '';
    }
    if(typeof(option) != "undefined" && option !== null){        
        jQuery.each( option, function( i, val ) {
            data[i] = val;
        });       
    }
    $('.loading-ajax').fadeIn();
    $.ajax({
        type: 'GET',
        url: base_url+'/ajax/property-data',
        data: data,
        dataType: 'html',
        headers: {'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')},
        success: function (res) {
            if($("#home-property").length){
                $('html,body').animate({
                    scrollTop: $("#home-property").offset().top -220
                });
            }
            
            $('#home-property').empty().html(res);
            $('.loading-ajax').fadeOut();
        },
        error: function (xhr, type) {
            toastr.error('Something wrong!');
            $('.loading-ajax').fadeOut();
        }
    });      
}

window.getDataAgent = function getDataAgent(page){  
    $.ajax({
        type: 'GET',
        url: base_url+'/ajax/agent-data',
        data: { page: page },
        dataType: 'html',
        headers: {'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')},
        success: function (data) {
            if($("#agent-data").length){
                $('html,body').animate({
                    scrollTop: $("#agent-data").offset().top -150
                });
            }
            $('#agent-data').empty().html(data);
        },
        error: function (xhr, type) {
            toastr.error('Something wrong!');
        }
    });      
}

window.provinceFor = function provinceFor(url, type, value){
   location.href =  url+type+value;
}

window.districtFor = function districtFor(url, type, value){
    location.href =  url+type+value;
}

window.communeFor = function communeFor(url, type, value){
    location.href =  url+type+value;
}

function needs_validation_ajax_form_submit(event, form)
{
	event.preventDefault();
	event.stopPropagation();
	
	if (form.checkValidity() === false) 
	{			
		$(form).addClass('was-validated');
		
		console.log('not validated')
		
		validated = false;
	}
	else
	{
		console.log('validated')
		
		validated = true;
	}
	
	return validated;
}


function needs_validation_ajax_none_submit(event, form) 
{			
	if (form.checkValidity() === false)  {		
		event.preventDefault();
		event.stopPropagation();
		
		$(form).addClass('was-validated');
		
		validated = false;
	} else {
		validated = true;
	}		
	
	return validated;
}


window.ajax_none_submit = function ajax_none_submit(event, form)
{
	if(needs_validation_ajax_none_submit(event, form))
	{		
		return true;
	}
}


window.ajax_form_submit = function ajax_form_submit(event, form)
{
	if(needs_validation_ajax_form_submit(event, form))
	{		
		return true;
	}
}

window.getSearchParams = function getSearchParams(name){
// function param(name) {
    return (location.search.split(name + '=')[1] || '').split('&')[0];
}

// check if if it is dark theme or not
// return boolean true or false
// function isDark() {
//     return $("html").attr("theme") == 'dark'
// }

// function darkModeToggle() {
//     if (isDark()) {
//         $("html").attr("theme", "light");
//     } else {
//         $("html").attr("theme", "dark");
//     }
// }

// function onClickDark() {
//     $('.theme-switcher').on('click', function () {
//         darkModeToggle();
//         if (isDark()) {
//             $(this).addClass('active')
//         } else {
//             $(this).removeClass('active')
//         }
//     })
// }

